import {
  getQueryStringHashToObject,
  generateRandomString,
  getCurrentProduct,
  getEventRouteAndUserHashDetails,
  getJWTDecodedObject,
} from '../app-actions';
import apiGetWithAuthHeaders from './auth-api';
import { apiPostCustom } from '../api/api-configuration';
import history from '../app-history';
import {
  AUTH_API_SUCCESS_USER_INFO,
  AUTH_API_FAILURE_USER_INFO,
  AUTH_API_REDIRECT_HOME_PAGE,
  APP_CONFIG,
  CIP_LOGIN_URL,
  AUTH_API_ACCESS_TOKEN_FAILURE,
  SECURE_AUTH_TOKEN_SUCCESS,
  DEBUG_MODE,
  ENABLE_LIVE_CHAT,
  LIVE_CHAT_SUPPORTED_PRODUCTS,
  SESSION_RENEWAL_COMPLETE,
  SESSION_RENEWAL_START,
  SESSION_RENEWAL_FAILED,
  SECURE_AUTH_PARTNER_BY_PASS,
} from '../app-constants';

export const failureAction = error => ({ type: AUTH_API_FAILURE_USER_INFO, data: error });

export const successActionTokenIdData = (tokenData, locationHash) => {
  sessionStorage.setItem('locationHash', locationHash);
  if (ENABLE_LIVE_CHAT) {
    // setting it so that sales force team can use for chat purposes;
    window.salesForceChatData = tokenData;
    const currentProduct = getCurrentProduct();

    if (window.initSFDCChat && LIVE_CHAT_SUPPORTED_PRODUCTS.includes(currentProduct)) {
      if (DEBUG_MODE) {
        console.log('live chat process started for product:', currentProduct);    // eslint-disable-line
      }
      window.initSFDCChat(window.liveChatContentData, currentProduct, DEBUG_MODE);
      const liveChatButton = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
      if (liveChatButton && liveChatButton.hidden) {
        liveChatButton.hidden = false;
      }
    } else {
      const liveChatButton = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
      if (liveChatButton && liveChatButton.hidden === false) {
        liveChatButton.hidden = true;
      }
    }
  }

  const parsedHash = getQueryStringHashToObject(locationHash);
  const accessTokenData = { company_id: tokenData.company_id, access_token: parsedHash.access_token };
  let currentLocation = window.location.pathname;
  if (DEBUG_MODE) {
    console.log(currentLocation); // eslint-disable-line
  }
  // check whether prod location has .htm, and if it is not present, then append .htm as reactBasePath has .htm
  // This check will only come into play in prod as authRedirectPath does not have .htm, and reactBasePath has .htm
  if (currentLocation.includes('.html') === false) {
    currentLocation += '.html';
  }
  const currentRoute = currentLocation.replace(APP_CONFIG.reactBasePath, '');
  if (window === window.parent) { // only to clear the url fragment for the original window, not for the iframe
    history.push(`${APP_CONFIG.reactBasePath}${currentRoute}`);
    if (DEBUG_MODE) {
      console.log(currentRoute); // eslint-disable-line
      history.push(`${APP_CONFIG.reactBasePath}/`);
    }
  }
  return { type: AUTH_API_SUCCESS_USER_INFO, data: accessTokenData };
};

export const redirectToHomePage = () => ({ type: AUTH_API_REDIRECT_HOME_PAGE });

export const redirectToLoginPage = () => {
  if (DEBUG_MODE) {
    console.log('in redirectToLoginPage'); // eslint-disable-line
  } else {
    window.location = CIP_LOGIN_URL + generateRandomString(9);
  }
  return { type: AUTH_API_ACCESS_TOKEN_FAILURE };
};

export const successActionTokenIdDataPartner = () => {
  const accessTokenData = { company_id: '222223232', access_token: 'askjdhkajhdksahdkhakd' };
  return { type: AUTH_API_SUCCESS_USER_INFO, data: accessTokenData };
};


export const getCustomerDetails = data => (dispatch) => {
  const endpoint = `${APP_CONFIG.authUserInfo}`;
  const eventRouteDetails = getEventRouteAndUserHashDetails();
  let parsedHash = getQueryStringHashToObject(data.locationHash);
  if (parsedHash.access_token && parsedHash.id_token) { // proper authentication process followed
    // validating the access token
    apiGetWithAuthHeaders(dispatch, endpoint, successActionTokenIdData, redirectToLoginPage, parsedHash, data.locationHash);
  } else if (parsedHash.cidn && (APP_CONFIG.authByPass === 'Y' || APP_CONFIG.authByPass === 'y')) { // by pass Auth
    const tokenData = { company_id: parsedHash.cidn };
    const dummyLocationHash = '#access_token=hjjghgj&id_token=hjhjgjhgj';
    dispatch(successActionTokenIdData(tokenData, dummyLocationHash));
  } else if (sessionStorage.getItem('locationHash')) { // refresh screen after proper authentication followed
    parsedHash = getQueryStringHashToObject(sessionStorage.getItem('locationHash'));
    apiGetWithAuthHeaders(dispatch, endpoint, successActionTokenIdData, redirectToLoginPage, parsedHash, sessionStorage.getItem('locationHash'));
  } else if (eventRouteDetails.isPartnerView) { // Direct partner view
    dispatch(successActionTokenIdDataPartner());
  } else {
    dispatch(redirectToHomePage());
  }
};

export const successSecureAuthToken = (responseData) => {
  sessionStorage.setItem('accessToken', responseData.access_token);
  sessionStorage.setItem('refreshToken', responseData.refresh_token);
  sessionStorage.setItem('idToken', responseData.id_token);

  const jwtValue = JSON.stringify(getJWTDecodedObject(responseData.id_token));
  sessionStorage.setItem('jwtData', jwtValue);

  return { type: SECURE_AUTH_TOKEN_SUCCESS };
};

export const successRenewalSecureAuthToken = (responseData) => {
  sessionStorage.setItem('accessToken', responseData.access_token);
  if (responseData.refresh_token) {
    sessionStorage.setItem('refreshToken', responseData.refresh_token);
  }
  return { type: SESSION_RENEWAL_COMPLETE };
};

export const tokenRenewalFailure = error => ({ type: SESSION_RENEWAL_FAILED, data: error });

export const getSecureAuthToken = () => (dispatch) => {
  const locationSearchObject = getQueryStringHashToObject(window.location.search);
  const hostname = window.location.hostname;
  const tokenEndPoint = `${APP_CONFIG.secureAuthUserInfo}`;

  const isStage = window.location.hostname.includes('stage.telstra');
  const secretValueStage = process.env.REACT_APP_STAGE_SECRET;
  const secretValueProd = process.env.REACT_APP_PROD_SECRET;

  const tokenData = {
    grant_type: 'authorization_code',
    code: locationSearchObject.code,
    redirect_uri: APP_CONFIG.secureAuthRedirectPath,
    client_id: APP_CONFIG.secureAuthClientId,
    client_secret: isStage ? secretValueStage : secretValueProd,
  };

  const requestData = Object.keys(tokenData)
    .map(key => `${key}=${encodeURIComponent(tokenData[key])}`)
    .join('&');

  const tokenCallOptions = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: requestData,
    url: tokenEndPoint,
  };

  if (hostname.includes('localhost') === false && SECURE_AUTH_PARTNER_BY_PASS === false) {
    if (locationSearchObject.code !== undefined) {
      apiPostCustom(dispatch, tokenCallOptions, successSecureAuthToken, failureAction);
    }
  } else if (SECURE_AUTH_PARTNER_BY_PASS) {
    const dummyJwtData = `{"idp":"SecureAuth664","auth_time":1631758061,"amr":["password"],"sub":"d874895","name":"Naeem, Farrukh","family_name":"Naeem","given_name":"Farrukh","email":"Farrukh.Naeem@test.team.telstra.com","email_verified":"true","org_unit":"90074983","groups":"ea90074983","department":"B2B Digital","jti":"4581e1300ce44b71a0fc9c651d730c1c","at_hash":"a9aLKn61WKy-lZorcMD7lQ","iat":1631758062,"iss":"https://sa.thyra.telstra.com/SecureAuth664","aud":"51f8df6465ed4eea8aa40cba25063062","exp":1631758661,"nbf":1631758061}`; // eslint-disable-line
    sessionStorage.setItem('jwtData', dummyJwtData);
    dispatch({ type: SECURE_AUTH_TOKEN_SUCCESS });
  } else {
    const dummyJwtData = `{"idp":"SecureAuth664","auth_time":1631758061,"amr":["password"],"sub":"d874895","name":"Naeem, Farrukh","family_name":"Naeem","given_name":"Farrukh","email":"Farrukh.Naeem@test.team.telstra.com","email_verified":"true","org_unit":"90074983","groups":"ea90074983","department":"B2B Digital","jti":"4581e1300ce44b71a0fc9c651d730c1c","at_hash":"a9aLKn61WKy-lZorcMD7lQ","iat":1631758062,"iss":"https://sa.thyra.telstra.com/SecureAuth664","aud":"51f8df6465ed4eea8aa40cba25063062","exp":1631758661,"nbf":1631758061}`; // eslint-disable-line
    sessionStorage.setItem('jwtData', dummyJwtData);
    dispatch({ type: SECURE_AUTH_TOKEN_SUCCESS });
  }
};


export const setupSecureAuthTokenRenewal = () => (dispatch) => {
  dispatch({ type: SESSION_RENEWAL_START });
  const refreshToken = sessionStorage.getItem('refreshToken');
  const hostname = window.location.hostname;
  const tokenEndPoint = `${APP_CONFIG.secureAuthUserInfo}`;

  const isStage = window.location.hostname.includes('stage.telstra');
  const secretValueStage = process.env.REACT_APP_STAGE_SECRET;
  const secretValueProd = process.env.REACT_APP_PROD_SECRET;

  const tokenData = {
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
    client_id: APP_CONFIG.secureAuthClientId,
    client_secret: isStage ? secretValueStage : secretValueProd,
  };

  const requestData = Object.keys(tokenData)
    .map(key => `${key}=${encodeURIComponent(tokenData[key])}`)
    .join('&');

  const tokenCallOptions = {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: requestData,
    url: tokenEndPoint,
  };

  if (hostname.includes('localhost') === false) {
    apiPostCustom(dispatch, tokenCallOptions, successRenewalSecureAuthToken, tokenRenewalFailure);
  }
};
